import { DataTable } from "@msuite/ui/table";
import { useMailboxEmails } from "@/hooks/use-mailbox-emails";
import { columns } from "./incoming-emails-table-config";

/** Props Interface */
interface IncomingEmailsTableProps {
	mailboxId: string;
	persistenceKey: `${string}-table`;
}

export function IncomingEmailsTable({ mailboxId, persistenceKey }: IncomingEmailsTableProps) {
	/** Query */
	const { emails, isLoading, queryKey, refetch } = useMailboxEmails(mailboxId);

	/** Render */
	return (
		<DataTable
			data={emails}
			columns={columns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={null}
			persistenceKey={persistenceKey}
			initialPinningState={{ start: ["receivedAt"], end: ["processingState"] }}
		/>
	);
}
